var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.extrasFilter = {
	init: function() {
		site.extrasFilter.initFilter();
	},

	initFilter: function() {
		var $grid = $('#events .items').isotope({
			itemSelector: '.item',
			layoutMode: 'fitRows',
			sortAscending: false,
			getSortData: {
				reykjanesbaerPinned: function($elem) {
					return $($elem).hasClass('reykjanesbaerPinned');
				},
				vogarPinned: function($elem) {
					return $($elem).hasClass('vogarPinned');
				},
				sudurnesjabaerPinned: function($elem) {
					return $($elem).hasClass('sudurnesjabaerPinned');
				},
				grindavikPinned: function($elem) {
					return $($elem).hasClass('grindavikPinned');
				},
			}
		});

		// store filter for each group
		let filters = {};
		let sortValues = [];
		let filterGroup = null;

		let $allButton = $(".button-group").find(`[data-filter='*']`);
		$allButton.addClass('checked');

		// do stuff when checkbox change
		$('#multiFilter').on('click', 'button', function(event) {
			let checkbox = event.target;
			let $checkbox = $(checkbox);

			// #_ prevents from scrolling to top of page
			location.hash = '#_';

			let group = $checkbox.parents('.option-set').attr('data-group');

			// create array for filter group, if not there yet
			filterGroup = filters[group];
			if (!filterGroup) {
				filterGroup = filters[group] = [];
			}

			if (group === 'municipation') {
				let $target = $(event.currentTarget);
				if ($target.hasClass('all')) {
					sortValues = [];
				}
				else {
					const sortValue = $target.attr('data-sort-value');
					const index = sortValues.indexOf(sortValue);
					if (sortValues.indexOf(sortValue) === -1) {
						sortValues.push(sortValue);
					}
					else {
						sortValues.splice(index, 1);
					}
				}
			}

			// Empty filters for filterGroup if all button has been pressed
			if ($checkbox.hasClass('all')) {
				filterGroup = [];
				filters[group] = [];
			}
			// add/remove filter
			else if ($checkbox.hasClass('checked') && !$checkbox.hasClass('all') ) {
				// add filter
				filterGroup.push(checkbox.value);
			}
			else {
				// remove filter
				const index = filterGroup.indexOf(checkbox.value);
				filterGroup.splice(index, 1);
			}

			let comboFilter = getComboFilter();
			$grid.isotope({ filter: comboFilter });

			onSortData();

			location.hash = 'filter=' + encodeURIComponent(comboFilter);
		});

		function getComboFilter() {
			let combo = [];
			for (let prop in filters) {
				let group = filters[prop];
				if (!group.length) {
					// no filters in group, carry on
					continue;
				}
				// add first group
				if (!combo.length) {
					combo = group.slice(0);
					continue;
				}
				// add additional groups
				let nextCombo = [];
				// split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
				for (let i = 0; i < combo.length; i++) {
					for (let j = 0; j < group.length; j++) {
						let item = combo[i] + group[j];
						nextCombo.push(item);
					}
				}
				combo = nextCombo;
			}
			return combo.join(', ');
		}

		// change checked class on buttons
		$('.button-group').each(function(i, buttonGroup) {
			let $buttonGroup = $(buttonGroup);
			$buttonGroup.on('click', 'button', function(event) {

				// Remove checked class from all button
				$buttonGroup.find('.all.checked').removeClass('checked')
				filterGroup = $buttonGroup.attr('data-group');

				let $button = $(event.currentTarget);
				// If All button is pressed, reset all filters for current buttonGroup
				if ($button[0].classList.contains('all')) {
					$buttonGroup.find('.checked').removeClass('checked')
				}
				if ($button[0].classList.contains('checked')) {
					$button.removeClass('checked');
				}
				else {
					$button.addClass('checked');
				}

				// If nothing is chosen we reset to all
				if (!buttonGroup.querySelector('.checked')) {
					$allButton = $('.' + filterGroup).find(`[data-filter='*']`);
					$allButton.addClass('checked');
				}

				if (filterGroup === 'municipation') {
					if ($button.attr('data-color') && !$button.hasClass('all')) {
						$backgroundColor = $button.hasClass('checked') ? $button.attr('data-color') : 'white';
						$color = $button.hasClass('checked') ? 'white' : '#0056A4';
						$button.css({
							'background-color': $backgroundColor,
							'color': $color,
						});
					}
					if ($button.hasClass('all')) {
						$buttonGroup.children('button').each(function(i) {
							// Skip All button
							if (i > 0) {
								$(this).css({
									'background-color': 'white',
									'color': '#0056A4',
								});
							}
						});
					}
				}
			});
		});

		$('button').mouseenter(function() {
			if ($(this).parent() && $(this).parent().hasClass('municipation')) {
				if (!$(this).hasClass('all') && !$(this).hasClass('checked')) {
					$(this).css({
						'background-color': $(this).attr('data-color'),
						'color': 'white',
					});
				}
			}
		});

		$('button').mouseleave(function() {
			if (!$(this).hasClass('all')) {
				if ($(this).parent() && $(this).parent().hasClass('municipation')) {
					$backgroundColor = $(this).hasClass('checked') ? $(this).attr('data-color') : 'white';
					$color = $(this).hasClass('checked') ? 'white' : '#0056A4';
					$(this).css({
						'background-color': $backgroundColor,
						'color': $color,
					});
				}
			}
		});

		function onHashchange() {
			let hashFilter = getHashFilter();
			// filter isotope
			$grid.isotope({
				itemSelector: '.item',
				filter: hashFilter,
				hiddenStyle: {
					opacity: 0,
					pointerEvents: 'none',
					transition: '.4s ease out',
				},
				visibleStyle: {
					opacity: 1,
					pointerEvents: 'all',
					transition: '.4s ease out',
				},
			});
		}

		$(window).on('hashchange', onHashchange);

		// init Isotope with hash filter
		onHashchange();

		// set initial checkboxes from hash
		let hashFilter = getHashFilter();
		if (hashFilter) {
			let splitHash = hashFilter.replaceAll(', ', '').split('.').slice(1);
			splitHash.forEach(function(filter) {
				let buttonId = document.getElementById(filter);

				if (buttonId) {
					let group = buttonId.parentElement.getAttribute('data-group');
					if (group === 'municipation') {
						if (buttonId.id) {
							sortValues.push(buttonId.id + 'Pinned');
						}
					}

					// create array for filter group, if not there yet
					filterGroup = filters[group];
					if (!filterGroup) {
						filterGroup = filters[group] = [];
					}
					if (!filters[group].includes('.' + filter)) {
						let prepareFilter = '.' + filter;
						filters[group].push(prepareFilter);
					}
				}
			});
			onSortData();
		}
		for(const [key, value] of Object.entries(filters)) {
			let allBtn = document.getElementById(key + 'All');

			if (allBtn.classList.contains('checked')) {
				allBtn.classList.remove('checked')
			}

			for (const [k, v] of Object.entries(value)) {
				if (v) {
					let trimmed = v.replace('.', '');
					let el = document.getElementById(trimmed);
					if (el && el.classList.contains(trimmed)) {
						if (!el.classList.contains('checked')) {
							el.classList.add('checked')
						}
					}

					if (key === 'municipation') {
						if (el.getAttribute('data-color') && !el.classList.contains('all')) {
							const backgroundColor = el.classList.contains('checked') ? el.getAttribute('data-color') : 'white';
							const color = el.classList.contains('checked') ? 'white' : '#0056A4';
							el.style.backgroundColor = backgroundColor;
							el.style.color = color;
						}
					}
				}
			}
		}

		function onSortData() {
			if (sortValues.length > 0) {
				$grid.isotope({
					sortBy: sortValues,
					sortAscending: false,
					hiddenStyle: {
						opacity: 0,
						pointerEvents: 'none',
					},
				});
			}
			else {
				$grid.isotope({
					sortBy: 'original-order',
					sortAscending: true,
					hiddenStyle: {
						opacity: 0,
						pointerEvents: 'none',
					},
				});
			}

			$grid.isotope('updateSortData').isotope();
		}

		function getHashFilter() {
			let matches = location.hash.match( /filter=([^&]+)/i );
			if (!matches) {
				return '';
			}
			return decodeURIComponent(matches[1]);
		}
	}
};

site.extrasCourses = {
	items: function() {
		$('a.all', '#multiFilter').on('click touchStart', function(e) {
			e.preventDefault()
			var scrollTop = $(window).scrollTop();
			location.hash = '';
			window.scrollTo(0, scrollTop);
		});

		$(window).load(function () {
			var $container = $('.items');
			if ($container.length) {
				$container.isotope({
					// options
					itemSelector: '.item',
					hiddenStyle: {
						opacity: 0,
						pointerEvents: 'none',
					},
					visibleStyle: {
						opacity: 1,
						pointerEvents: 'all',
					}
				});
				$container.addClass('loaded');
			}
		});
	},

	view: function() {
		if ($('.images img').length > 1) {
			site.owl.init('.images .owl', {
				loop: false,
				dots: false,
				nav: true,
				autoplay: true,
				autoplayTimeout: 5000,
				items: 1,
				navText: ["", ""],
			});
		}
		else {
			$owl = $('.owl');
			$owl.addClass('single-image');
		}
	}
};

site.phone = {
	init:function(toggle, element_area, element_open, element_close) {
		$(toggle).on('click touchStart', function(e) {
			e.stopPropagation();
			e.preventDefault();

			var $body = $('body');
			if (!$body.hasClass(element_open)) {
				$body.addClass(element_open);
			}
			else {
				site.phone.close(element_open, element_close);
			}

			$(element_area).on('click touchStart', function(e) {
				e.stopPropagation();
			});
			$('body.' + element_open).on('click touchStart', function (e) {
				site.phone.close(element_open, element_close);
			});
		});
	},

	close:function(element_open, element_close) {
		var $body = $('body');
		if ($body.hasClass(element_open)) {
			$body.addClass(element_close).removeClass(element_open);
			setTimeout(function() {
				$body.removeClass(element_close);
			},400);
		}
	}
};

site.frontpage = {
	init: function() {

	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.phone.init('a#phoneToggle', '#phoneArea', 'phone-open', 'phone-closing');
	site.phone.init('a#styrkirToggle', '#styrkirArea', 'styrkir-open', 'styrkir-closing');
	site.extrasCourses.items();
	site.extrasCourses.view();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
